import { render, staticRenderFns } from "./DashboardStatusCounts.vue?vue&type=template&id=6e6fa9c3&"
import script from "./DashboardStatusCounts.vue?vue&type=script&lang=js&"
export * from "./DashboardStatusCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports